import React, { useCallback, useEffect, useState } from 'react';

import { SpinnerOverlay, SubmissionButtons, TextArea } from '@components/common';

import { useAlarmDetails } from '@hooks/alarms/alarmsByVendor/useAlarmDetails';

import { IActiveAlarmOran } from '@interfaces/alarms/alarm';

import { MAX_255_LENGTH } from '@constants/validationMessages';

import styles from './AcknowledgeAlarm.module.scss';

interface IAcknowledgeAlarmProps {
	onClose: () => void;
	onSubmit: (id: string, message: string) => void;
	setSelectedAlarm: (alarm: IActiveAlarmOran | null) => void;
	id: string;
	vendor: string;
	isLoading: boolean;
}

const AcknowledgeAlarm = ({
	onClose,
	onSubmit,
	setSelectedAlarm,
	vendor,
	id,
	isLoading,
}: IAcknowledgeAlarmProps) => {
	const { alarm, isLoadingAlarm } = useAlarmDetails(vendor, id);

	const [acknowledgeMessage, setAcknowledgeMessage] = useState(alarm?.acknowledgeNotes || '');

	const onChange = useCallback((value: string) => {
		setAcknowledgeMessage(value);
	}, []);

	const submitHandler = useCallback(() => {
		onSubmit(id, acknowledgeMessage);
	}, [acknowledgeMessage, id, onSubmit]);

	useEffect(() => {
		if (alarm) {
			setSelectedAlarm(alarm);
		}
	}, [alarm, setSelectedAlarm]);

	return (
		<div className={styles.wrapper}>
			{isLoadingAlarm && <SpinnerOverlay />}
			<TextArea
				isMaxLengthCounter
				label='Comment'
				maxLength={MAX_255_LENGTH}
				name='acknowledgeMessage'
				onChange={onChange}
				placeholder='Add your comment'
				value={acknowledgeMessage}
			/>
			<SubmissionButtons
				isLoading={isLoading}
				negativeHandler={onClose}
				positiveHandler={submitHandler}
				positiveLabel='Proceed'
			/>
		</div>
	);
};

export default AcknowledgeAlarm;
